module.exports = __webpack_public_path__ + "img/Course-body.eb2a8c2d.jpg";